import { useState } from "react";
import { FaShieldAlt } from "react-icons/fa";
import Button from "../controls/button/button";
import TextField from "../controls/text-field/text-field";
import InfoMessage from "../controls/info-message/info-message";
import { strengthScore } from "../ui-helpers";
import LoginIllustration from "./LoginIllustration.png";
import './password.css';

/**
 * Password change component.
 * @param {ReactDOM.props} props Component properties.
 * @returns Generated component.
 */
const Password = (props) => {

    // Initialize states
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [valid, setValid] = useState(false);

    /**
     * Checks whether password is valid.
     * @returns True if password is valid, False otherwise.
     */
    const isValid = () => {

        // Get elements
        const strength = document.getElementById('strength');
        const passEl = document.getElementById('new-password');
        const confirmEl = document.getElementById('password-confirm');
        const password = passEl.value;
        const confirm = confirmEl.value;

        // Check score
        const score = strengthScore(password);
        if (score > 80) {
            strength.classList.remove('critical');
            strength.classList.remove('warning');
            strength.classList.add('ok');
            strength.innerText = 'Mot de passe sécurisé';
        }
        else if (score > 60) {
            strength.classList.remove('critical');
            strength.classList.add('warning');
            strength.classList.remove('ok');
            strength.innerText = 'Mot de passe acceptable';
        }
        else {
            strength.classList.add('critical');
            strength.classList.remove('warning');
            strength.classList.remove('ok');
            strength.innerText = 'Mot de passe trop faible';
        }

        // Return result
        return password === confirm && score > 60;
    }

    /**
     * Validate handler.
     */
    const validate = () => {
        const passEl = document.getElementById('new-password');
        props?.onValidate?.(passEl.value);
    }

    const handlePasswordChange = (value) => {
        setPassword(value);
        setValid(isValid());
    }

    const handleConfirmChange = (value) => {
        setConfirm(value);
        setValid(isValid());
    }

    return (
        <div style={{
            position: 'relative',
            display: 'flex',
            minHeight: '100vh',
            background: '#f7f9fb',
            overflow: 'hidden'
        }}>
            {/* Illustration en fond, centrée */}
            <img
                src={LoginIllustration}
                alt="Illustration sécurité"
                style={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 'calc(100vw - 420px)',
                    height: 'auto',
                    minWidth: 800,
                    maxWidth: 'none',
                    zIndex: 1,
                    objectFit: 'contain',
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}
            />
            <div style={{
                position: 'relative',
                width: 420,
                height: '100vh',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '48px 40px',
                boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
                zIndex: 2
            }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
                    <div style={{
                        width: 48, height: 48, borderRadius: 12, background: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 16
                    }}>
                        <span style={{ color: '#fff', fontWeight: 700, fontSize: 28, fontFamily: 'Inter, Arial' }}>D</span>
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 22, color: '#22223b', fontFamily: 'Inter, Arial' }}>Définir le mot de passe</div>
                </div>
                <div style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>
                    Vous devez définir votre mot de passe. Nous vous recommandons qu'il contienne au moins : 12 caractères, une lettre en minuscule, une lettre en majuscule, un chiffre, un caractère de ponctuation.
                </div>
                <TextField
                    id='new-password'
                    label='Mot de passe'
                    dataType='string'
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(evt) => { handlePasswordChange(evt.target.value) }}
                    onKeyUp={(evt) => { handlePasswordChange(evt.target.value) }}
                    password
                    large
                />
                <div id="strength" className="critical" style={{ margin: '10px 0 18px 0' }}>Mot de passe trop faible</div>
                <TextField
                    id='password-confirm'
                    label='Confirmation'
                    dataType='string'
                    placeholder="Confirmation"
                    value={confirm}
                    onChange={(evt) => { handleConfirmChange(evt.target.value) }}
                    onKeyUp={(evt) => { handleConfirmChange(evt.target.value) }}
                    password
                    large
                    style={{ marginTop: 8 }}
                />
                <Button
                    onClick={validate}
                    disabled={!valid}
                    large
                    style={{ marginTop: 28, width: '100%' }}
                >
                    Enregistrer
                    <FaShieldAlt />
                </Button>
            </div>
        </div>
    )
}
export default Password;